exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aside.sidebar[_ngcontent-c6] {\n  font-size: 14px;\n  width: 120px !important;\n  position: fixed;\n  z-index: 9;\n  left: 0;\n  padding-top: 72px;\n  height: 100%;\n  background-size: 100%;\n  box-shadow: 5px 0 7px rgba(0, 0, 0, 0.08);\n  overflow-y: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/layout/layout/layout.component.scss
// module id = ../../../../../src/app/layout/layout/layout.component.scss
// module chunks = 1